import { JSX } from 'react/jsx-runtime';
import {
	Button,
	ButtonSize,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	Tooltip,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { faBroom } from '@fortawesome/pro-solid-svg-icons/faBroom';
import { useMailbox } from '../../Providers/NewMailboxProvider';
import FilterItem from '../../../_Global/Components/Filter/FilterItem';

const MapSearchParams = (key: string, value: any) => {
	let readableString = '';

	switch (key) {
		case 'startDate':
			readableString = `From: ${value}`;
			break;
		case 'endDate':
			readableString = `To: ${value}`;
			break;
		case 'mailType':
			readableString = value === 0 ? 'Parcels' : 'Letters';
			break;
		case 'scanned':
			readableString = value === 0 ? 'Unopened' : 'Scanned';
			break;
		case 'term':
			readableString = `Containing: ${value}`;
			break;
		case 'unreadStatus':
			readableString = `Unread ${value === 0 ? 'Envelopes' : 'Scans'}`;
			break;
		case 'incomingRecipientNameIds':
			readableString = `Name ${value}`;
			break;
		case 'mailTagIds':
			readableString = `Tag ${value}`;
			break;
		default:
			readableString = 'Unmapped Value';
	}

	return readableString;
};

function MailboxSearchPills() {
	const { t } = useTranslation();

	const { searchParams, RemoveUrlSearchParam } = useMailbox();

	const filterEntries: JSX.Element[] = [];

	if (searchParams) {
		Array.from(searchParams.entries()).forEach((item, value) => {
			filterEntries.push(
				<FilterItem
					content={MapSearchParams(item[0], item[1])}
					key='activeSearchParam{key}'
					callback={() => RemoveUrlSearchParam(item[0])}
				/>,
			);
		});
	}

	return (
		<StackHorizontal gap={FlexGap.ExtraSmall} justify={FlexJustify.Start} align={FlexAlign.Center}>
			<small className='sub-heading'>Active Filters:</small>

			<StackHorizontal gap={FlexGap.ExtraSmall} wrap>
				{filterEntries}
			</StackHorizontal>

			{filterEntries.length > 1 && (
				<Tooltip content={t('actions.clearFilters')}>
					<Button title={t('actions.clearFilters')} icon={faBroom} iconOnly size={ButtonSize.Small} />
				</Tooltip>
			)}
		</StackHorizontal>
	);
}

export { MailboxSearchPills };
